module.exports = __webpack_public_path__ + "img/responsive crc-02.23aa68f0.jpg";